<template>
    <div class="jump-warphd nav-bar-fixed">


        <van-collapse v-model="activeNames" class="pro-hd">
            <van-collapse-item title="出库单明细信息" name="22">

                <van-row v-for="obj in item" style="margin-bottom: 10px;border:5px solid #f8f8f8;">
                    <div class="pro-item">
                        <van-cell title="出库单号" :value="obj.deliveryGoodsorder.delivery_order_no"
                                  style="margin-right: 2px"/>
                        <van-cell title="是否使用价目表价格" :value="obj.deliveryGoodsorder.has_erp_price"/>
                        <van-cell title="是否需要财务审核" :value="obj.deliveryGoodsorder.need_fm"/>
                        <van-cell title="出库单状态" :value="obj.deliveryGoodsorder.deliveryStatusName"/>
                        <van-cell title="是否已到货" :value="obj.deliveryGoodsorder.reached"/>

                    </div>
                    <div style="color: #3C6EEB;margin-left: 10px;font-size: 14px">商品信息</div>
                    <div v-for="(good,index) in obj.deliveryGoodsorder.outOrderDetail">
                        <van-row>{{good.goods_name}}</van-row>
                        <van-col span="10" class="jump-cart-item-img">
                            <img :src="good.goodsPic"/>
                        </van-col>
                        <van-col span="24" class="jump-cart-item-warp">


                            <van-field
                                    :value="good.delivery_price"
                                    label="价目表价格"
                                    readonly
                            />

                            <van-field
                                    :value="good.goods_out_code"
                                    label="出库编码"
                                    readonly
                            />

                            <van-field
                                    :value="good.out_count"
                                    label="本次出库数量"
                                    readonly
                            />

                            <van-field
                                    :value="good.received_count"
                                    label="实际到货数量"
                                    readonly
                            />


                            <van-field
                                    :value="good.dictdata_value"
                                    label="供货商"
                                    readonly
                            />


                        </van-col>
                    </div>
                    <div style="margin-left: 15px;border-bottom: 5px solid #f7f7f7;" v-if="item.length>0">
                        <p style="margin-left: -15px;border-bottom: 5px solid #f7f7f7;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                        <p>业务实体：{{obj.deliveryGoodsorder.erpInfo.cux_ou_name}}</p>
                        <p>库存组织：{{obj.deliveryGoodsorder.erpInfo.warehouse_name}}</p>
                        <p>订单类型：{{obj.deliveryGoodsorder.erpInfo.business_type_name}}</p>
                        <p>付款条件：{{obj.deliveryGoodsorder.erpInfo.payment_term_name}}</p>
                        <p>价目表：{{obj.deliveryGoodsorder.erpInfo.price_list_name}}</p>
                        <p>赠品是否同步ERP：{{obj.deliveryGoodsorder.erpInfo.syn_gift_erp_name}}</p>
                        <p>同步ERP状态：
                            <van-button type="info" size="mini" class="blues"
                                        @click="seeOrderInfo(obj.deliveryGoodsorder)">
                                查看
                            </van-button>
                        </p>
                        <p>车次安排：{{obj.deliveryGoodsorder.faHuo.train_type_name}}</p>
                        <p>司机手机号：{{obj.deliveryGoodsorder.faHuo.mobile_driver}}</p>
                        <p>车牌号：{{obj.deliveryGoodsorder.faHuo.plate_no}}</p>
                        <p>发车时间：{{obj.deliveryGoodsorder.faHuo.departure_time}}</p>
                        <p>司机姓名：{{obj.deliveryGoodsorder.faHuo.driverName}}</p>
                        <p>司机身份证号：{{obj.deliveryGoodsorder.faHuo.driverIdnumber}}</p>
                    </div>

                </van-row>
            </van-collapse-item>
        </van-collapse>

        <!--<van-collapse v-model="erpinfo" class="pro-hd">
            <van-collapse-item title="订单类型及发货信息" name="1">

                <van-row v-for="obj in item">
                    <p>业务实体：{{obj.deliveryGoodsorder.erpInfo.cux_ou_name}}</p>
                    <p>库存组织：{{obj.deliveryGoodsorder.erpInfo.warehouse_name}}</p>
                    <p>订单类型：{{obj.deliveryGoodsorder.erpInfo.business_type_name}}</p>
                    <p>付款条件：{{obj.deliveryGoodsorder.erpInfo.payment_term_name}}</p>
                    <p>价目表：{{obj.deliveryGoodsorder.erpInfo.price_list_name}}</p>
                    <p>赠品是否同步ERP：{{obj.deliveryGoodsorder.erpInfo.syn_gift_erp_name}}</p>
                    <p>同步ERP状态：
                        <van-button type="info" size="mini" class="blues" @click="seeOrderInfo(obj.deliveryGoodsorder)">
                            查看
                        </van-button>
                    </p>
                    <p>车次安排：{{obj.deliveryGoodsorder.faHuo.train_type_name}}</p>
                    <p>司机手机号：{{obj.deliveryGoodsorder.faHuo.mobile_driver}}</p>
                    <p>车牌号：{{obj.deliveryGoodsorder.faHuo.plate_no}}</p>
                    <p>发车时间：{{obj.deliveryGoodsorder.faHuo.departure_time}}</p>
                </van-row>

            </van-collapse-item>
        </van-collapse>-->


    </div>
</template>
<script>
    import {NavBar, Cell, CellGroup, Field, Button, Row, Col, Collapse, CollapseItem,Panel} from "vant";

    export default {
        name: "userOrderArrival",
        components: {
            [Panel.name]: Panel,
            [NavBar.name]: NavBar,
            [CellGroup.name]: CellGroup,
            [Cell.name]: Cell,
            [Field.name]: Field,
            [Button.name]: Button,
            [Row.name]: Row,
            [Col.name]: Col,
            [Collapse.name]: Collapse,
            [CollapseItem.name]: CollapseItem
        },
        props: {
            //发货单商品
            goodsList: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            //发货单
            delivery: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            workFlow: {},
            data: {}
        },
        watch: {
            goodsList: {
                immediate: true,    // 这句重要
                handler(val) {
                    /* let that = this
                     var arr = [];
                     let delivery_price = []
                     let out_count = []
                     let received_count = []
                     for (var i = 0; i < val.length; i++) {
                         delivery_price[i] = val[i].delivery_price
                         out_count[i] = val[i].out_count
                         received_count[i] = val[i].received_count
                         arr.push(val[i]);
                     }
                     that.delivery_price = delivery_price
                     that.out_count = out_count
                     that.received_count = received_count
                     that.delverygoods = arr;
                     let json={}
                     json['deliveryPrice']=this.delivery_price
                     json['outCount']=this.out_count
                     json['receivedCount']=this.received_count
                     this.$emit('dataJson',json)*/
                }
            },
            delivery: {
                immediate: true,    // 这句重要
                handler(val) {
                    for (var i = 0; i < val.length; i++) {
                        this.item.push(val[i]);
                    }
                }
            }

        },
        data() {
            return {
                erpinfo: ["1"],
                activeNames: ["22"],
                item: [],
                delverygoods: []
            };
        },
        mounted: function () {

        },

        methods: {
            deliveryPrice() {
                let json = {}
                json['deliveryPrice'] = this.delivery_price
                json['outCount'] = this.out_count
                json['receivedCount'] = this.received_count
                this.$emit('dataJson', json)
            },
            outCount() {
                let json = {}
                json['deliveryPrice'] = this.delivery_price
                json['outCount'] = this.out_count
                json['receivedCount'] = this.received_count
                this.$emit('dataJson', json)
            },
            received_count() {
                let json = {}
                json['deliveryPrice'] = this.delivery_price
                json['outCount'] = this.out_count
                json['receivedCount'] = this.received_count
                this.$emit('dataJson', json)
            },
            seeOrderInfo(item) {
                let that = this
                that.$router.push({
                    path: '/erporder',
                    query: {
                        id: item.erpInfo.erpinfoId,
                        deliveryOrderId:item.id 
                    }
                })
            }
        },
    };
</script>
<style lang="less">
    @bule-thame: #3C6EEB;

    .jump-warphd {
        .pro-hd {
            .van-collapse-item__title {
                background-color: #f7f7f7;
                color: @bule-thame;
                .van-cell__value, i {
                    color: @bule-thame;
                }
            }
        }
        .van-collapse-item__content {
            padding: 0;
        }
        .pro-item {
            border-bottom: 5px solid #f7f7f7;
        }
        .p-tol {
            padding: 10px 10px 20px;
            color: @bule-thame;
            font-size: 14px;
            text-align: right;
        }
        .van-hairline--top-bottom::after {
            border-width: 0;
        }
        .van-cell:not(:last-child)::after {
            border: none;
        }
        .jump-cart-item-warp {
            color: black;
        }
        p {
            margin-top: 12px;
        }
    }
</style>
